export default "__VITE_ASSET__a0jfFc5n__"